import React, { useState } from 'react';
import { Bus, TrendingUp, Award } from 'lucide-react';
import RouteCard from '../components/RouteCard';
import ServiceCard from '../components/ServiceCard';
import ThruWayDetails from '../components/ThruWayDetails';
import { routesData, otherProjectsData } from '../data/projectsData';
import './Projects.css';

const Projects = () => {
  const [expandedRoute, setExpandedRoute] = useState(null);

  const toggleRoute = (routeId) => {
    setExpandedRoute(expandedRoute === routeId ? null : routeId);
  };

  return (
    <div className="projects">
      {/* Hero Section */}
      <section className="projects-hero section-dark">
        <div className="container">
          <div className="projects-hero-content">
            <h1>Our Routes & Services</h1>
            <p className="projects-subtitle">
              Connecting communities across the Eastern United States with reliable rail transportation
            </p>
          </div>
        </div>
      </section>

      {/* Passenger Routes */}
      <section className="section">
        <div className="container-wide">
          <div className="section-header">
            <h2>Passenger Routes</h2>
            <p>Click on any route to view all station stops</p>
          </div>
          <div className="routes-detailed-grid">
            {routesData.map((route) => (
              <RouteCard
                key={route.id}
                route={route}
                isExpanded={expandedRoute === route.id}
                onToggle={() => toggleRoute(route.id)}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Other Services */}
      <section className="section section-gray">
        <div className="container-wide">
          <div className="section-header">
            <h2>Additional Services</h2>
          </div>
          <div className="projects-grid">
            {otherProjectsData.map((project) => (
              <ServiceCard key={project.title} project={project} />
            ))}
          </div>
        </div>
      </section>

      {/* Thru-Way Details Section */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Thru-Way Connections Service</h2>
            <p>Complimentary bus service ensuring you reach your destination</p>
          </div>
          
          {/* Thru-Way Bus Photo */}
          <div className="thruway-photo-container">
            <img 
              src="https://customer-assets.emergentagent.com/job_western-rail-hub/artifacts/32gio7da_121G_20260524_221025_0000.png"
              alt="AG&WESTERN Thru-Way Bus 121G"
              className="thruway-bus-photo"
            />
          </div>

          <ThruWayDetails />
        </div>
      </section>

      {/* CTA Section */}
      <section className="section section-gray">
        <div className="container">
          <div className="projects-cta">
            <h2>Ready to Travel With Us?</h2>
            <p>
              Experience reliable rail transportation with AG&WESTERN. Book your trip today 
              and discover the comfort of stress-free travel.
            </p>
            <a href="/contact" className="btn btn-primary">
              Contact Us for Bookings
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Projects;
